import { createContext } from "react";
import { Socket } from "socket.io-client";

interface SocketInterface {
  socket: Socket | null
}

export const SocketContext = createContext<SocketInterface | null>(null);
